module.exports = __webpack_public_path__ + "static/6-3d47db867683db2b9b8aa12e9792a6be.jpg";